<template>
    <div class="paper-wrapper d-flex align-items-center justify-content-center">
        <!-- <Header label="Recover Highered user" overlap="small" /> -->
        <Paper
            class="paper p-5 d-flex flex-column align-items-center shadow"
            slot="center"
            padding
        >
            <div class="image-wrapper mb-4">
                <img class="image" :src="LOGO" alt="logo" />
            </div>

            <div v-if="isDefaultState()" class="wrapper">
                <h6 class="mb-3 primary-color">
                    {{ $t('recoverpassword.createPassword') }}
                </h6>

                <form class="w-100" @submit.prevent="onResetPassword">
                    <TextField
                        :label="$t('recoverpassword.newPasswordLabel')"
                        :placeholder="
                            $t('recoverpassword.newPasswordPlaceholder')
                        "
                        type="password"
                        v-model="password"
                        margin
                        padding
                        required
                    />
                    <TextField
                        :label="$t('recoverpassword.confirmPasswordLabel')"
                        :placeholder="
                            $t('recoverpassword.confirmPasswordPlaceholder')
                        "
                        type="password"
                        v-model="confirmPassword"
                        padding
                        required
                        :error="errorMessage !== ''"
                        :helperText="errorMessage"
                    />
                    <BaseButton class="mt-4 w-100" variant="primary">{{
                        $t('recoverpassword.resetPasswordButton')
                    }}</BaseButton>
                </form>
            </div>
            <div
                v-else-if="isLoadingState()"
                class="progress-wrapper p-5 d-flex flex-column align-items-center justify-content-center"
            >
                <Spinner class="primary-color" size="lg" />
                <h6 class="caption mt-3">
                    {{ $t('recoverpassword.resettingPassword') }}
                </h6>
            </div>
            <ErrorModule
                v-show="isErrorState()"
                v-on:stateChange="changeState"
            />
            <SuccessModule v-if="isSuccessState()" />
        </Paper>
    </div>
</template>

<script>
// Miscelleanous
import states from './states';
import LOGO from '~/config/LOGO.png';
import {
    isInvalidToken,
    passwordResetErrorMapper,
} from '~/utils/errors/authErrorMapper';

// Components
import Header from '~/components/layouts/Header';
import MainLayout from '~/components/layouts/mainlayout/MainLayout';
import Spinner from '~/components/builders/Spinner';

// Page specific components
import ErrorModule from './components/ErrorModule';
import SuccessModule from './components/SuccessModule';

export default {
    name: 'RecoverPassword',
    components: { Header, MainLayout, Spinner, ErrorModule, SuccessModule },
    data: function() {
        return {
            LOGO: LOGO,
            state: states.DEFAULT,
            userId: this.$route.query.userId || '',
            token: decodeURI(this.$route.query.token || ''),
            password: '',
            confirmPassword: '',
            errorMessage: '',
            isLoading: false,
        };
    },
    methods: {
        isDefaultState() {
            return this.state === states.DEFAULT;
        },
        isSuccessState() {
            return this.state === states.SUCCESS;
        },
        isErrorState() {
            return this.state === states.ERROR;
        },
        isLoadingState() {
            return this.state === states.LOADING;
        },
        setState(state) {
            this.state = state;
        },
        validateQueryParamters() {
            // Show not be able to enter this page unless 'userId' and 'token' is
            // provided in query
            if (!this.userId || !this.token) {
                this.$router.push(this.$URLS.findjobs);
            }
        },
        onResetPassword() {
            // Check if password and confirm password is equal
            if (this.password !== this.confirmPassword) {
                this.errorMessage = this.$t(
                    'recoverpassword.passwordsNotMatching'
                );
                return;
            }

            this.state = states.LOADING;

            this.$interfaces.user['reset-password']
                .post({
                    body: {
                        token: this.token,
                        userId: this.userId,
                        password: this.password,
                    },
                })
                .then(() => {
                    this.state = states.SUCCESS;
                })
                .catch(error => {
                    if (isInvalidToken(error)) {
                        this.state = states.ERROR;
                        return;
                    }
                    this.errorMessage = passwordResetErrorMapper(error);
                    this.state = states.DEFAULT;
                });
        },
        changeState(state) {
            console.log('Changing state to: ', state);
            this.state = state;
        },
    },
    mounted() {
        this.validateQueryParamters();
        this.$interfaces.logInModule.setDisabledPopup();
    },
};
</script>

<style scoped>
.paper-wrapper {
    width: 100vw;
    height: 100vh;
}
.paper {
    max-width: 500px;
    width: 400px;
    margin: auto;
}
.wrapper {
    width: 100%;
    max-width: 800px;
    margin: auto;
}
.progress-wrapper {
    min-height: 175px;
}

/* IMAGE */
.image-wrapper {
    margin: auto;
    width: 140px;
    max-width: 140px;
}
.image {
    width: 100%;
    height: auto;
    object-fit: cover;
}

@media only screen and (max-width: 600px) {
    .paper {
        width: 100vw;
        height: 100vh;

        padding: 36px !important;
    }
}
</style>
